/* ==========================================================================
   Fusion Grit Welkomstkorting Popup — JavaScript
   --------------------------------------------------------------------------
   MODIFIED FOR POOPY THEME INTEGRATION:
   - bindTrigger() is DISABLED. The popup is opened manually by quickAddToCart()
     in quick-add-to-cart.liquid after the items array is already built.
   - acceptOffer() and declineOffer() now receive the pre-built items array
     from the existing cart flow, so addons/warranty etc. are preserved.
   - window.FusionGritPopup.openWithItems(items) is the integration entry point.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Config & state -------------------------------------------- */

  var CONFIG = window.FG_CONFIG || {};

  var BAG_USAGE_PER_MONTH = {
    1: 2.0,
    2: 3.5,
    3: 4.5,
    4: 5.5
  };

  var state = {
    open: false,
    cats: 2,
    lastFocusedEl: null,
    initialized: false,
    pendingItems: null   // holds the items array passed in from quickAddToCart
  };

  var dom = {};

  /* ---------- Public API ------------------------------------------------ */

  var FusionGritPopup = {
    init:          initialize,
    open:          openPopup,
    openWithItems: openWithItems,  // <-- integration entry point
    close:         closePopup,
    setCats:       setCats
  };

  window.FusionGritPopup = FusionGritPopup;

  /* ---------- Initialization -------------------------------------------- */

  function initialize() {
    if (state.initialized) return;

    dom.popup = document.getElementById('fg-popup');
    if (!dom.popup) return;

    cacheDom();
    bindEvents();
    setCats(state.cats);

    state.initialized = true;
  }

  function cacheDom() {
    dom.modal           = dom.popup.querySelector('.fg-popup__modal');
    dom.closeButtons    = dom.popup.querySelectorAll('[data-fg-close]');
    dom.catButtons      = dom.popup.querySelectorAll('[data-fg-cats]');
    dom.bagDurationEls  = dom.popup.querySelectorAll('[data-fg-bag-duration]');
    dom.bulkDurationEls = dom.popup.querySelectorAll('[data-fg-bulk-duration]');
    dom.acceptBtn       = dom.popup.querySelector('[data-fg-accept]');
    dom.declineBtn      = dom.popup.querySelector('[data-fg-decline]');
  }

  function bindEvents() {
    dom.closeButtons.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closePopup();
      });
    });

    dom.catButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cats = parseInt(btn.getAttribute('data-fg-cats'), 10);
        setCats(cats);
      });
    });

    if (dom.acceptBtn) {
      dom.acceptBtn.addEventListener('click', function () {
        acceptOffer();
      });
    }

    if (dom.declineBtn) {
      dom.declineBtn.addEventListener('click', function () {
        declineOffer();
      });
    }

    document.addEventListener('keyup', function (e) {
      if (state.open && (e.key === 'Escape' || e.key === 'Esc')) {
        closePopup();
      }
    });

    // NOTE: bindTrigger() is intentionally NOT called here.
    // The popup is triggered externally via FusionGritPopup.openWithItems(items).
  }

  /* ---------- Integration entry point ----------------------------------- */

  /**
   * Called by quickAddToCart() in quick-add-to-cart.liquid.
   * Receives the already-built items array (main product + addons/warranty).
   *
   * If the FG popup should show: stores the items, opens popup.
   * If not (e.g. already seen this session, or no FG variant configured):
   * returns false so quickAddToCart can proceed normally.
   *
   * @param {Array}    items          - Cart items array from quickAddToCart
   * @param {Element}  triggerButton  - The ATC button that was clicked (for focus restore)
   * @returns {boolean} true if popup was opened, false if caller should proceed normally
   */
  function openWithItems(items, triggerButton) {
    if (!shouldShowPopup()) return false;

    state.pendingItems = items;
    state.lastFocusedEl = triggerButton || document.activeElement;
    openPopup();
    return true;
  }

  /* ---------- Should show? ---------------------------------------------- */

  function shouldShowPopup() {
    if (!CONFIG.fusionGritVariantId) {
      console.warn('[FusionGrit] No Fusion Grit variant ID configured — popup disabled');
      return false;
    }
    return true;
  }

  /* ---------- Open / Close --------------------------------------------- */

  function openPopup() {
    if (state.open) return;

    // Reset CTA buttons on every open
    if (dom.acceptBtn) setCtaLoading(dom.acceptBtn, false);
    if (dom.declineBtn) setCtaLoading(dom.declineBtn, false);

    // iOS Safari: save scroll position before fixing body
    state.scrollY = window.scrollY;

    dom.popup.hidden = false;
    document.body.classList.add('fg-popup-open');
    // iOS Safari: apply saved scroll as top offset so page doesn't jump
    document.body.style.top = '-' + state.scrollY + 'px';
    state.open = true;

    requestAnimationFrame(function () {
      if (dom.acceptBtn) dom.acceptBtn.focus();
    });
  }

  function closePopup() {
    if (!state.open) return;

    dom.popup.hidden = true;
    document.body.classList.remove('fg-popup-open');
    // iOS Safari: restore scroll position after un-fixing body
    document.body.style.top = '';
    window.scrollTo(0, state.scrollY || 0);
    state.open = false;
    state.pendingItems = null;

    if (state.lastFocusedEl && typeof state.lastFocusedEl.focus === 'function') {
      state.lastFocusedEl.focus();
    }
  }

  /* ---------- Cat count toggle ----------------------------------------- */

  function setCats(cats) {
    cats = parseInt(cats, 10);
    if (!BAG_USAGE_PER_MONTH[cats]) return;
    state.cats = cats;

    dom.catButtons.forEach(function (btn) {
      var btnCats = parseInt(btn.getAttribute('data-fg-cats'), 10);
      var isActive = btnCats === cats;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });

    var bagDur  = formatBagDuration(cats);
    var bulkDur = formatBulkDuration(6, cats);

    dom.bagDurationEls.forEach(function (el)  { el.textContent = bagDur;  });
    dom.bulkDurationEls.forEach(function (el) { el.textContent = bulkDur; });
  }

  function formatBagDuration(cats) {
    var days = 30.4 / BAG_USAGE_PER_MONTH[cats];
    if (days >= 13) return '±' + Math.round(days / 7) + ' weken';
    return '±' + Math.round(days) + ' dagen';
  }

  function formatBulkDuration(bags, cats) {
    var months = bags / BAG_USAGE_PER_MONTH[cats];
    if (months < 0.9) return '±' + Math.round(months * 4.3) + ' weken voorraad';
    if (months < 1.25) return '±1 maand voorraad';
    var rounded = Math.round(months * 2) / 2;
    var label = (rounded % 1 === 0) ? String(rounded) : String(rounded).replace('.', ',');
    return '±' + label + ' maanden voorraad';
  }

  /* ---------- Accept / Decline flows ----------------------------------- */

  function acceptOffer() {
    if (!dom.acceptBtn) return;
    setCtaLoading(dom.acceptBtn, true);

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Poopy items + FG item together
    var items = (state.pendingItems || []).slice();
    items.push({
      id: parseInt(CONFIG.fusionGritVariantId, 10),
      quantity: 1,
      properties: { '_fg_welkom': '1' }
    });

    var formData = {
      items: items.map(function(p) {
        return { id: p.id, quantity: p.quantity || 1, properties: p.properties, selling_plan: p.selling_plan };
      }),
      sections: cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function(s) { return s.id; }) : []
    };

    var config = fetchConfig('json');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(formData);

    fetch(routes.cart_add_url, config)
      .then(function(r) { return r.json(); })
      .then(function(response) {
        if (response.errors) throw new Error(response.errors);
        // fetch('/discount/' + encodeURIComponent(CONFIG.discountCode));
        closePopup();
        if (cart) {
          var cartObj = Object.assign({}, response.items[0], { sections: response.sections });
          cart.renderContents(cartObj);
          cart.classList.remove('is-empty');
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id });
      })
      .catch(function(err) {
        console.error('[FusionGrit] accept flow failed:', err);
        setCtaLoading(dom.acceptBtn, false);
        alert('Er ging iets mis bij het toevoegen aan je winkelmandje. Probeer het nogmaals.');
      });
  }

  function declineOffer() {
    if (!dom.declineBtn) return;
    setCtaLoading(dom.declineBtn, true);

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Add Poopy only, no FG item
    var items = (state.pendingItems || []).slice();

    var formData = {
      items: items.map(function(p) {
        return { id: p.id, quantity: p.quantity || 1, properties: p.properties, selling_plan: p.selling_plan };
      }),
      sections: cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function(s) { return s.id; }) : []
    };

    var config = fetchConfig('json');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(formData);

    fetch(routes.cart_add_url, config)
      .then(function(r) { return r.json(); })
      .then(function(response) {
        if (response.errors) throw new Error(response.errors);
        closePopup();
        if (cart) {
          var cartObj = Object.assign({}, response.items[0], { sections: response.sections });
          cart.renderContents(cartObj);
          cart.classList.remove('is-empty');
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id });
      })
      .catch(function(err) {
        console.error('[FusionGrit] decline flow failed:', err);
        setCtaLoading(dom.declineBtn, false);
        alert('Er ging iets mis bij het toevoegen aan je winkelmandje. Probeer het nogmaals.');
      });
  }

  /**
   * Shopify AJAX Cart API — /cart/add.js
   */
  function addItemsToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (txt) {
          throw new Error('Cart add failed: ' + res.status + ' ' + txt);
        });
      }
      return res.json();
    });
  }

  function setCtaLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      btn.setAttribute('disabled', 'disabled');
      btn.dataset.fgOriginalText = btn.textContent;
      btn.textContent = 'Even geduld…';
    } else {
      btn.removeAttribute('disabled');
      if (btn.dataset.fgOriginalText) {
        btn.textContent = btn.dataset.fgOriginalText;
        delete btn.dataset.fgOriginalText;
      }
    }
  }

  /* ---------- Auto-init on DOM ready ----------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();